import { useEffect, useRef, useState } from "react";

export function useAudioRecorder(onData?: (chunk: Blob) => void) {
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const chunksRef = useRef<Blob[]>([]);

  useEffect(() => {
    return () => {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    mediaRecorderRef.current = recorder;
    chunksRef.current = [];
    setAudioUrl(null);
    recorder.ondataavailable = (e) => {
      chunksRef.current.push(e.data);
      onData?.(e.data);
    };
    recorder.start();
    setRecording(true);
  };

  const stop = () =>
    new Promise<Blob | null>((resolve) => {
      const recorder = mediaRecorderRef.current;
      if (!recorder) {
        resolve(null);
        return;
      }
      recorder.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        setAudioUrl(URL.createObjectURL(blob));
        resolve(blob);
      };
      recorder.stop();
      setRecording(false);
    });

  return { start, stop, recording, audioUrl };
}
